import { IActionContext, createObservableDataAction, IAction, IGeneric, IAny, ICreateActionContext } from "@msdyn365-commerce/core";
import { CacheType, IActionInput } from "@msdyn365-commerce/retail-proxy";
import { getProductListsByProductIdsAsync, IProductListByProductId } from "./get-product-lists-by-product-ids";
import { getSelectedProductIdFromActionInput } from "@msdyn365-commerce-modules/retail-actions";

export class GetProductListsByProductIdInput implements IActionInput {

    public productId: number;

    public constructor(productId: number) {
        this.productId = productId;
    }

    public shouldCacheOutput = (): boolean => false;

    public getCacheKey = () => `ProductListsByProductId`;
    public getCacheObjectType = () => 'ProductListsByProductId';
    public dataCacheType = (): CacheType => 'request';
}

const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): GetProductListsByProductIdInput => {
    const productId = getSelectedProductIdFromActionInput(inputData);

    if (productId) {
        return new GetProductListsByProductIdInput(+productId);
    }

    throw new Error('Unable to create GetProductListsByProductIdInput, no productId found on module config or query');
};

export const getProductListsByProductIdAction = async (input: GetProductListsByProductIdInput, ctx: IActionContext): Promise<IProductListByProductId[]> => {
    if (!ctx.requestContext.user.isAuthenticated) {
        return [];
    }
    return getProductListsByProductIdsAsync({ callerContext: ctx }, [input.productId]);
};

export const getProductListsByProductId = createObservableDataAction({
    id: 'src/actions/get-product-lists-by-product-id',
    action: <IAction<IProductListByProductId[]>>getProductListsByProductIdAction,
    input: createInput
});

export default getProductListsByProductId;
